import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';

const Reviews = () => {
  const [reviews, setReviews] = useState([]);
  const [loading, setLoading] = useState(true);

  // 1. 데이터 로드
  const fetchReviews = async () => {
    try {
      const res = await axios.get('/api/reviews');
      setReviews(res.data.reviews || []);
    } catch (err) {
      console.error("리뷰 로드 실패:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchReviews();
  }, []);

  // 2. 별점 렌더링 헬퍼 함수
  const renderStars = (rating) => {
    const stars = [];
    for (let i = 1; i <= 5; i++) {
      stars.push(i <= rating ? '★' : '☆');
    }
    return stars.join('');
  };

  // 3. 삭제 처리
  const handleDelete = async (reviewId) => {
    if (!window.confirm('정말 이 리뷰를 삭제하시겠습니까?')) return;

    try {
      const res = await axios.post(`/api/review/delete/${reviewId}`);
      if (res.data.success) {
        alert("리뷰가 삭제되었습니다.");
        // 화면에서 즉시 제거
        setReviews(reviews.filter(r => r.id !== reviewId));
      }
    } catch (err) {
      alert("삭제 중 오류가 발생했습니다.");
    }
  };

  if (loading) return <div className="container mt-5 text-center">로딩 중...</div>;

  return (
    <div className="container my-2 px-0" style={{ maxWidth: '600px', paddingTop: '20px' }}>
      <h2 className="mb-3 mx-3">리뷰 목록</h2>

      {reviews.length === 0 ? (
        <div
        className="alert text-secondary mx-2"
        style={{ background: '#f1f3f5', fontSize: '13px' }}
        >
        작성한 리뷰가 없습니다.
        </div>
      ) : (
        reviews.map((review) => (
          <div key={review.id} className="review-card" style={styles.reviewCard}>
            <div className="review-header" style={styles.reviewHeader}>
              <div>
                <Link to={`/product/${review.product_id}`} style={styles.productLink}>
                  {review.product_name}
                </Link>
                <span style={styles.reviewDate}>
                  | {new Date(review.created_at).toLocaleDateString('ko-KR')}
                </span>
              </div>
              <div className="review-actions">
                <Link to={`/review/edit/${review.id}`} style={styles.actionLink}>수정</Link>
                <button 
                  onClick={() => handleDelete(review.id)} 
                  style={styles.actionBtn}
                >
                  삭제
                </button>
              </div>
            </div>
            
            <div style={styles.reviewRating}>
              {renderStars(review.rating)}
            </div>

            <div style={styles.reviewContent}>
              {review.content}
            </div>

            {review.image_path && (
              <img 
                src={`/static/${review.image_path}`}
                alt="리뷰 이미지" 
                style={styles.reviewImage}
              />
            )}

          </div>
        ))
      )}
    </div>
  );
};

// CSS-in-JS 스타일 정의
const styles = {
  container: { maxWidth: '600px', margin: '20px auto 40px', padding: '0 15px' },
  title: { marginBottom: '20px', fontSize: '1.5rem', fontWeight: 'bold' },
  reviewCard: { border: '1px solid #ddd', padding: '18px', marginBottom: '20px', borderRadius: '5px', background: '#ffffff' },
  reviewHeader: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '5px' },
  productLink: { color: '#212529', textDecoration: 'none', fontWeight: '700' },
  reviewDate: { color: '#999', fontSize: '0.85rem', marginLeft: '5px' },
  reviewRating: { color: '#f7b500', margin: '6px 0', fontSize: '1.1rem' },
  reviewContent: { whiteSpace: 'pre-wrap', lineHeight: '1.4', color: '#444', fontSize: '0.85rem' },
  reviewImage: { maxWidth: '180px', marginTop: '10px', borderRadius: '6px' },
  actionLink: { fontSize: '0.85rem', color: '#6c757d', textDecoration: 'none', marginRight: '10px' },
  actionBtn: { fontSize: '0.85rem', color: '#6c757d', background: 'none', border: 'none', cursor: 'pointer', padding: 0 }
};

export default Reviews;